import Button from 'blocks/Button';
import Modal from 'components/Modal';
import { ModalFC } from 'config/types';
import { ModalEnterConfirmationFormModel } from './modalProductPurchase.interface';
import * as S from './modalProductPurchase.styles';

import DoneAllIcon from '@mui/icons-material/DoneAll';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Text } from 'blocks/Text';
import { useTranslation } from 'react-i18next';
const ProductPurchaseModal: ModalFC<ModalEnterConfirmationFormModel> = ({
  open,
  onClose,
  statusPurchase,
  setCardDetail,
}) => {
  const { t } = useTranslation();
  const handleClose = () => {
    onClose && onClose();
  };

  return (
    <Modal open={open} onClose={handleClose} width="400px">
      <S.Wrapper>
        <S.SidebarIconAndName $active={statusPurchase ? statusPurchase.status : ''}>
          <S.SidebarListItemSvg $active={statusPurchase ? statusPurchase.status : ''}>
            {statusPurchase && statusPurchase.status === 'purchased' ? <DoneAllIcon /> : <HighlightOffIcon />}
          </S.SidebarListItemSvg>
          <S.SidebarListItemSpan $active={statusPurchase ? statusPurchase.status : ''}>
            {statusPurchase && statusPurchase.status === 'purchased'
              ? `${t('pages.services.Products.sections.confirmation.status.Success')}`
              : `${t('pages.services.Products.sections.confirmation.status.purchased')}`}
          </S.SidebarListItemSpan>
        </S.SidebarIconAndName>
        <S.Text as={Text}>
          {t('pages.services.Products.sections.confirmation.TraceNumber')} :
          {statusPurchase ? statusPurchase.traceNumber : ''}
        </S.Text>

        <Button
          fullWidth
          width={200}
          onClick={() => {
            setCardDetail([]);
            handleClose();
          }}
        >
          {t('pages.services.Products.sections.confirmation.okBtn')}
        </Button>
      </S.Wrapper>
    </Modal>
  );
};

export default ProductPurchaseModal;
